import React, { FC, useEffect, useState } from 'react'
import classes from './WorkersHeader.module.scss'
//検索
import FindReplaceIcon from '@mui/icons-material/FindReplace'
//追加
import AddCircleIcon from '@mui/icons-material/AddCircle'
//保存
import SaveIcon from '@mui/icons-material/Save'
//キャンセル
import CancelIcon from '@mui/icons-material/Cancel'
import { Buttons } from '../../../../uikit/atoms/buttons/Buttons'
import { TextField, useTheme } from '@mui/material'
import { Worker, WorkerWithDiary } from '../../../../../types'
import { useGetWorkerInfo } from '../../../../../hooks/api/workers/useGetWorkerInfo'
import { useGetDiaryList } from '../../../../../hooks/api/posts/useGetDiraryList'
import { useGetHasDiaryList } from '../../../../../hooks/api/posts/useGetHasDiaryList'
import PersonSearchIcon from '@mui/icons-material/PersonSearch'
import WorkerSearchDialog from '../../../../modal/workerSearch/WorkerSearchDialog'
import { workerInfoType } from '../../../../singleInput/SingleInputMain'
import { formatWorkerId } from '../../../../../utils/variables/workerId'

type Props = {
  onSave: () => void
  onCancel: () => void
  setWorkerList: React.Dispatch<React.SetStateAction<WorkerWithDiary[]>>
  workerList: Array<Worker>
  workingDate: { obj: Date; text: string }
}

const WorkersHeader: FC<Props> = (props) => {
  const { onSave, onCancel, setWorkerList, workerList, workingDate } = props
  const theme = useTheme()
  const [isWorkerSearchOpen, setIsWorkerSearchOpen] = useState(false)
  const { getHasDiaryList } = useGetHasDiaryList()
  const getWorkerInfo = useGetWorkerInfo()
  const [isEnableAdd, setIsEnableAdd] = useState(false)
  const [workerInfoForKana, setWorkerInfoForKana] = useState<workerInfoType>({
    workerId: '',
    workerName: '',
    departmentId: null,
    departmentName: '',
    place: '',
    jobId: null,
  })
  //社員マスタ情報-4
  const [workerInfo, setWorkerInfo] = useState<WorkerWithDiary>({
    workerId: '',
    workerName: '',
    departmentId: null,
    departmentName: '',
    place: '',
    jobId: null,
    isDiaryExist: false,
  })
  //エラーメッセージ-2
  const [errorWorkerName, setErrorWorkerName] = useState({
    isShow: true,
    text: '未設定',
  })
  //社員番号入力
  const handleChangeWorkerId = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length <= 5) {
      setWorkerInfo((prevState) => ({
        ...prevState,
        workerId: e.target.value,
      }))
      if (e.target.value.length == 0) {
        setErrorWorkerName({ isShow: true, text: '未設定' })
      } else {
        setErrorWorkerName({ isShow: false, text: '' })
      }
      // setErrorWorkerName({ isShow: true, text: "未設定" });
    }
  }
  const handleFocusWorkerId = () => {
    // console.log("Field is focused");
    setWorkerInfo((prevState) => ({
      ...prevState,
      workerId: '',
      workerName: '',
      departmentId: null,
      departmentName: '',
      place: '',
      jobId: null,
      isDiaryExist: false,
    }))
    setErrorWorkerName({ isShow: true, text: '未設定' })
  }
  //検索
  const onSearch = async () => {
    // console.log("Field has lost focus");
    if (
      workerInfo.workerId.length > 0 ||
      workerInfoForKana.workerId.length > 0
    ) {
      let res: any
      if (workerInfoForKana.workerId.length > 0) {
        res = await getWorkerInfo(workerInfoForKana.workerId)
      } else {
        res = await getWorkerInfo(workerInfo.workerId)
      }
      // console.log(res);
      if (res) {
        const hasDiaryList = await getHasDiaryList(
          [Number(res[5])],
          workingDate.text
        )
        console.log(hasDiaryList)
        setWorkerInfo((prevState) => ({
          ...prevState,
          workerId: res[5],
          workerName: res[0],
          departmentId: res[1],
          departmentName: res[6],
          place: res[3],
          jobId: res[2],
          isDiaryExist: hasDiaryList ? hasDiaryList[0].isDiaryExist : false,
        }))
        setErrorWorkerName({
          isShow: false,
          text: `${res[6]}`,
        })
      } else {
        setWorkerInfo((prevState) => ({
          ...prevState,
          workerName: '',
          departmentId: null,
          departmentName: '',
          place: '',
          jobId: null,
          isDiaryExist: false,
        }))
        setErrorWorkerName({ isShow: true, text: '見つかりませんでした' })
      }
    }
  }
  useEffect(() => {
    if (
      workerInfo.workerId.length > 0 &&
      workerInfo.workerName.length > 0 &&
      errorWorkerName.isShow == false
    ) {
      setIsEnableAdd(true)
    } else {
      setIsEnableAdd(false)
    }
  }, [workerInfo.workerId, workerInfo.workerName, errorWorkerName.isShow])

  const handleClickAddButton = () => {
    const existingWorker = workerList.find(
      (worker) => worker.workerId === workerInfo.workerId
    )
    if (!existingWorker) {
      setWorkerList((prevState) => [
        ...prevState,
        {
          workerId: workerInfo.workerId,
          workerName: workerInfo.workerName,
          departmentId: workerInfo.departmentId,
          departmentName: workerInfo.departmentName,
          place: workerInfo.place,
          jobId: workerInfo.jobId,
          isDiaryExist: workerInfo.isDiaryExist,
        },
      ])
      setErrorWorkerName({ isShow: true, text: '未設定' })
    } else {
      setErrorWorkerName({ isShow: true, text: '登録済です' })
    }
    setWorkerInfo((prevState) => ({
      ...prevState,
      workerId: '',
      workerName: '',
      departmentId: null,
      departmentName: '',
      place: '',
      jobId: null,
      isDiaryExist: false,
    }))
  }
  useEffect(() => {
    if (workerInfoForKana.workerId.length > 0) {
      setWorkerInfo((prevState) => ({
        ...prevState,
        workerId: formatWorkerId(workerInfoForKana.workerId),
      }))
      setWorkerInfoForKana({
        workerId: '',
        workerName: '',
        departmentId: null,
        departmentName: '',
        place: '',
        jobId: null,
      })
      onSearch()
    }
  }, [workerInfoForKana])

  return (
    <div className={classes.rootContainer}>
      <div className={classes.buttons}>
        <div className={classes.saveButtons}>
          <div>
            <Buttons
              disabled={false}
              onClick={onSave}
              caption={'保存'}
              icon={<SaveIcon />}
              width={24}
              height={24}
              fontSize={24}
            />
          </div>
          <div>
            <Buttons
              disabled={false}
              onClick={onCancel}
              caption={'キャンセル'}
              icon={<CancelIcon />}
              width={24}
              height={24}
              fontSize={24}
            />
          </div>
          <p>社員登録・削除</p>
        </div>
        <div className={classes.searchKanaButton}>
          <Buttons
            disabled={false}
            onClick={() => setIsWorkerSearchOpen(true)}
            caption={'カナ'}
            icon={<PersonSearchIcon />}
            width={26}
            height={26}
            fontSize={24}
          />
        </div>
      </div>
      <div className={classes.hr} />
      <div className={classes.inputArea}>
        <div className={classes.worker}>
          <TextField
            helperText={errorWorkerName.text}
            error={errorWorkerName.isShow}
            label="社員番号"
            variant="standard"
            type="number"
            multiline={false}
            value={workerInfo.workerId}
            sx={{
              height: '70px',
              width: '100px',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              //スピンボタンの無効化-効いていない
              ':global(input[type="number"]::-webkit-outer-spin-button)': {
                WebkitAppearance: 'none',
                margin: 0,
              },
              ':global(input[type="number"]::-webkit-inner-spin-button)': {
                WebkitAppearance: 'none',
                margin: 0,
              },

              '& .MuiInputBase-input': {
                color: theme.palette.foreColor.main, // テキストフィールド内のフォントカラーをプライマリーカラーに
                fontSize: '16px',
                // その他のスタイル設定...
              },
              '& label': {
                color: theme.palette.foreColor.main, // 通常時のラベル色
                //backgroundColor:"white"
              },
              '& label.Mui-focused': {
                color: theme.palette.foreColor.main, // ラベルの色をprimary.mainに指定
              },
              '& .MuiInput-underline:before': {
                borderBottomColor: theme.palette.foreColor.main, // 通常時のボーダー色
              },
              '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                borderBottomColor: theme.palette.foreColor.main, // ホバー時のボーダー色
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.palette.foreColor.main, // 通常時のボーダー色(アウトライン)
                },
                '&:hover fieldset': {
                  borderColor: theme.palette.foreColor.main, // ホバー時のボーダー色(アウトライン)
                },
                '& .MuiInputBase-root': {},
              },
            }}
            onChange={handleChangeWorkerId}
            onFocus={handleFocusWorkerId}
            onBlur={onSearch}
            placeholder="1234or01234"
            InputLabelProps={{
              shrink: true,
            }}
          />
          <p>{workerInfo.workerName}</p>
        </div>
        <div className={classes.rightMenu}>
          <div className={classes.buttons}>
            <div>
              <Buttons
                disabled={false}
                onClick={onSearch}
                caption={'検索'}
                icon={<FindReplaceIcon />}
                width={24}
                height={24}
                fontSize={24}
              />
            </div>

            <div>
              <Buttons
                disabled={!isEnableAdd}
                onClick={handleClickAddButton}
                caption={'追加'}
                icon={<AddCircleIcon />}
                width={24}
                height={24}
                fontSize={24}
              />
            </div>
          </div>
          <p>合計{workerList.length}名</p>
        </div>
      </div>
      <div className={classes.hr} />
      {isWorkerSearchOpen && (
        <WorkerSearchDialog
          setIsShow={setIsWorkerSearchOpen}
          setWorkerInfo={setWorkerInfoForKana}
        />
      )}
    </div>
  )
}

export default WorkersHeader
